import { GuiDetailMandant } from "./GuiDetailMandant";

export class GuiDetailSupportMandant extends GuiDetailMandant {
}
